import { useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Window } from '@progress/kendo-react-dialogs';
import { useNotificationAPI } from '../../components/NotificationProvider';
import { protectedResources } from '../../authConfig';
import { StreckDropDownTypes, TypedStreckDropDown } from "../../components/TypedStreckDropDown"
import ManageLab from "./Lab_Manage"
import { LoadPage } from '../../components/LoadPage';
import { loginPrompt } from '../../utils/loginPrompt';

const MergeDuplicateLab = () => {
    const { addNotification, addNotifications } = useNotificationAPI();

    const [isLoading, setIsLoading] = useState(false);
    const [duplicateLabId, setDuplicateLabId] = useState(0);
    const [destinationLabId, setDestinationLabId] = useState(0);
    const [showFinalConfirmationWindow, setShowFinalConfirmationWindow] = useState(false);

    const intialMergeCheck = () => {
        if (duplicateLabId === 0) {
            addNotification("You must select a Duplicate Lab", "MergeDuplicateLab", "info");
            return;
        }
        if (destinationLabId === 0) {
            addNotification("You must select a Destination Lab", "MergeDuplicateLab", "info");
            return;
        }
        if (destinationLabId === duplicateLabId) {
            addNotification("The Duplicate Lab can not be the same as the Destination Lab", "MergeDuplicateLab", "info");
            return;
        }

        setShowFinalConfirmationWindow(true);
    }

    const mergeLabs = () => {
        const thenFunction = (data: any, errors: any) => {
            if (!data?.notifications?.hasNotifications && errors?.errors?.length == 0) {
                addNotification("Labs merged successfully!", "MergeDuplicateLab", "success");
            }

            setIsLoading(false);
            setShowFinalConfirmationWindow(false);
        }

        setIsLoading(true);
        loginPrompt("POST", protectedResources.apiDuplicateLabMerge.endpoint + "MergeLab", {
            DuplicateLabId: duplicateLabId,
            DestinationLabId: destinationLabId
        }, addNotifications, thenFunction, () => { setIsLoading(false); });
    }

    return <>
        {showFinalConfirmationWindow &&
            <Window title={'Merge Labs'} onClose={() => { setShowFinalConfirmationWindow(false); }} initialWidth={650} initialHeight={330}>
                <div>
                    All of the information associated with the lab on the left will be associated with the lab on the right. <br></br><br></br>
                    The lab on the left will be deleted and will no longer show up in drop downs. <br></br><br></br>
                    Please check to make sure that you have selected the right labs, then click "Merge" if they are correct.<br></br><br></br>
                    <Button onClick={() => mergeLabs()} >Merge</Button>
                </div>
            </Window>}

        <LoadPage isLoading={isLoading}>
            <Button onClick={() => intialMergeCheck()} >Merge Labs</Button>
            <br></br><br></br>
            <div style={{ width: "40%", minWidth: "500px", display: "inline-block", paddingRight: "15px" }}>
                <h3>Duplicate Lab</h3>
                <TypedStreckDropDown
                    streckDropDownType={StreckDropDownTypes.Lab}
                    handleChange={(result: any) => setDuplicateLabId(result)}
                    selectedId={duplicateLabId}
                    required={true}
                    disabled={false}
                ></TypedStreckDropDown>
                {duplicateLabId !== 0 &&
                    <ManageLab
                        labId={duplicateLabId}
                        key={"DuplicateLabID:" + duplicateLabId}>
                    </ManageLab>}
            </div>
            <div style={{ width: "40%", minWidth: "500px", display: "inline-block" }}>
                <h3>Destination Lab</h3>
                <TypedStreckDropDown
                    streckDropDownType={StreckDropDownTypes.Lab}
                    handleChange={(result: any) => setDestinationLabId(result)}
                    selectedId={destinationLabId}
                    required={true}
                    disabled={false}
                ></TypedStreckDropDown>
                {destinationLabId !== 0 &&
                    <ManageLab
                        labId={destinationLabId}
                        key={"DestinationLabID:" + destinationLabId}>
                    </ManageLab>}
            </div>
        </LoadPage>
    </>
};

export default MergeDuplicateLab;